import useHttpPost from "./useHttpPost";

export default function usePostRentalMargin(target){
    return useHttpPost("rentalmargin", "post", {}, target)
}